import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconIntellijIdea({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="m2.325 0 5 .6L9.07 2.594 11.025.25 16 4.276l-.3 9.25L9.55 16l-3.358-2.178L1.3 15.6 2.325 12l.213-.715-2.363-1.86 1.387-2.576L0 6.325 2.325 0zM13 3H3v10h10V3z"/>
            <path fill={fill} d="M3.95 11.125H7.7v.625H3.95v-.625zM6.624 5.05V4.3H4.576v.75h.574v2.624h-.574v.776h2.048v-.776h-.576V5.05h.576zm2 3.45a1.677 1.677 0 0 1-.825-.175 1.968 1.968 0 0 1-.55-.45l.575-.65c.104.114.221.215.35.3.121.07.26.105.4.1a.465.465 0 0 0 .4-.175.733.733 0 0 0 .15-.525V4.25h.924v2.7c.01.221-.024.442-.099.65a1.25 1.25 0 0 1-.35.55c-.284.21-.623.332-.975.35z"/>
        </svg>
    );
}

export default IconIntellijIdea;
